module.exports = __webpack_public_path__ + "media/images/vector/TiktokLogo-0e7bccfdcd1ae904599313ee3d98209e.svg";